import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "m10.512 9.302.651 2.791H0s.187.837.278.93c.28.465.559 1.024.932 1.395 1.767 2.047 4.837 2.884 7.348 3.349 1.767.373 3.535.466 5.302.558l2.047 5.488h1.116l.652 1.769h-.93l-1.582 5.116h15.535l-1.581-5.116h-.93l.65-1.769h1.116s.93-5.673 3.814-8.278C36.558 12.93 40 12.558 40 12.558V9.302zM26.14 23.348c-.745.465-1.582.465-2.14.839-.372.185-.558.743-.558.743-.372-.837-.837-1.117-1.395-1.302-.559-.186-1.582-.093-2.977-1.303-.93-.837-1.023-1.953-.93-2.512v-.278c0-.093 0-.187.093-.28.185-.557.65-1.115 1.58-1.488 0 0-.65.931 0 1.861.374.559 1.117.837 1.769.465.278-.186.465-.558.558-.838.185-.65.185-1.302-.373-1.767-.837-.743-1.022-1.766-.465-2.418 0 0 .186.837 1.023.743.558 0 .558-.185.373-.371-.093-.279-1.303-2.047.465-3.349 0 0 1.115-.745 2.419-.651-.745.093-1.582.558-1.86 1.303v.092c-.28.745-.094 1.581.465 2.326.371.559.836 1.024 1.023 1.767-.28-.093-.465 0-.652.187a.89.89 0 0 0-.186.836c.093.187.28.372.465.372h.28c.278-.092.465-.465.371-.743.187.185.279.651.187.93 0 .278-.187.558-.28.743-.093.187-.278.373-.372.558-.093.187-.186.374-.186.559s0 .465.093.651c.372.559 1.117 0 1.303-.465.279-.558.185-1.21-.186-1.768 0 0 .651.373 1.116 1.675.372 1.117-.28 2.418-1.023 2.883"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M0 0h40v40H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }